import { AddOnOrderProps } from '../AddOnOrder';

const HostingAddOn = ({ orderData, setOrderData }: AddOnOrderProps) => {
  const handleWebHosting = () => {
    setOrderData({
      ...orderData,
      webHosting: !orderData.webHosting,
    });
  };

  const handleEmailHosting = () => {
    setOrderData({
      ...orderData,
      emailHosting: !orderData.emailHosting,
    });
  };

  const handleDomain = () => {
    setOrderData({
      ...orderData,
      domain: !orderData.domain,
    });
  };

  return (
    <div>
      <p className="mt-8 text-base font-semibold text-primary-black">
        Need hosting? We can take care of this for you!
      </p>
      <div className="mt-4 flex items-start rounded-xl border border-[#CFD8E2] p-5">
        <input
          type="checkbox"
          className="h-[18px] w-[18px] checked:bg-black"
          onChange={handleWebHosting}
          checked={orderData.webHosting}
        />
        <div className="ml-3">
          <p className="text-sm font-semibold text-primary-black lg:text-base">
            1 Year Web Hosting
          </p>
          <p className="mt-1.5 text-xs lg:text-sm">
            Fast and reliable international level hosting with SSL
            certification, renewable annually.
          </p>
          <p className="mt-2 text-[10px] text-[#9FA6B0] lg:text-xs">
            Up to 5gb storage
          </p>
          <div className="my-3 border-b border-[#E3E8ED]" />
          <p className="text-sm font-bold text-primary-black lg:text-base">
            ₣2000
          </p>
        </div>
      </div>

      <div className="mt-3 flex items-start rounded-xl border border-[#CFD8E2] p-5">
        <input
          type="checkbox"
          className="h-[18px] w-[18px] checked:bg-black"
          onChange={handleEmailHosting}
          checked={orderData.emailHosting}
        />
        <div className="ml-3">
          <p className="text-sm font-semibold text-primary-black lg:text-base">
            1 Year Email Hosting
          </p>
          <p className="mt-1.5 text-xs lg:text-sm">
            Secure and reliable anti-spam email hosting, renewable annually.
          </p>
          <p className="mt-2 text-[10px] text-[#9FA6B0] lg:text-xs">
            Up to 20 users with 2gb storage per account
          </p>
          <div className="my-3 border-b border-[#E3E8ED]" />
          <p className="text-sm font-bold text-primary-black lg:text-base">₣600</p>
        </div>
      </div>

      <p className="mt-8 text-base font-semibold text-primary-black">
        Want us to manage or purchase your domain for you?
      </p>

      <div className="mt-4 flex items-start rounded-xl border border-[#CFD8E2] p-5">
        <input
          type="checkbox"
          className="h-[18px] w-[18px] checked:bg-black"
          onChange={handleDomain}
          checked={orderData.domain}
        />
        <div className="ml-3">
          <p className="text-sm font-semibold text-primary-black lg:text-base">
            1 Year Domain Services
          </p>
          <p className="mt-1.5 text-xs lg:text-sm">
            We purchase, manage and maintain your domain, renewable annually or
            transfer your existing domain for you so we can manage your renewal
            seamlessly.
          </p>
          <p className="mt-2 text-[10px] text-[#9FA6B0] lg:text-xs">
            Does not include domain price
          </p>
          <div className="my-3 border-b border-[#E3E8ED]" />
          <p className="text-sm font-bold text-primary-black lg:text-base">₣200</p>
        </div>
      </div>
    </div>
  );
};

export default HostingAddOn;
